export default [
  {
    path: '/',
    name: 'Login',
    component: () => import('@/components/functions/Auth/PgLogin')
  },
  {
    path: '/Top',
    name: 'Top',
    component: () => import('@/components/functions/Top/TopIndex')
  },
  {
    path: '/M0001User',
    name: 'M0001User',
    component: () => import('@/components/functions/M0001User/M0001UserIndex')
  },
  {
    path: '/PageManagement',
    name: 'PageManagement',
    component: () => import('@/components/functions/PageManagement/PageCodeEditor')
  },
  {
    path: '/PagePreview',
    name: 'PagePreview',
    component: () => import('@/components/functions/PageManagement/PagePreview')
  },
  {
    path: '/Client',
    name: 'Client',
    component: () => import('@/components/functions/Client/ClientIndex')
  },
  {
    path: '/Project',
    name: 'Project',
    component: () => import('@/components/functions/Project/ProjectIndex')
  },
  {
    path: '/ProjectImagePreview',
    name: 'ProjectImagePreview',
    component: () => import('@/components/functions/Project/ProjectImagePreview')
  },
  {
    path: '/Product',
    name: 'Product',
    component: () => import('@/components/functions/Product/ProductIndex')
  },
  {
    path: '/ProductionProcedure',
    name: 'ProductionProcedure',
    component: () => import('@/components/functions/ProductionProcedure/ProductionProcedureIndex')
  },
  {
    path: '/Frame',
    name: 'Frame',
    component: () => import('@/components/functions/Frame/FrameIndex')
  },
  {
    path: '/FrameType',
    name: 'FrameType',
    component: () => import('@/components/functions/FrameType/FrameTypeIndex')
  },
  {
    path: '/ChangePassword',
    name: 'ChangePassword',
    component: () => import('@/components/functions/ChangePassword/ChangePasswordIndex')
  },
  {
    path: '/PoHWorkDontTouch',
    name: 'PoHWorkDontTouch',
    component: () => import('@/components/functions/PoHWorkDontTouch/PreviewPage')
  },
  {
    path: '*',
    redirect: '/'
  }
]



// WEBPACK FOOTER //
// ./src/router/routes.js